import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";

// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
import agent from "../../agent";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import "./AccountSetting.css";

import { Grid, Typography, Button, TextField, IconButton, Paper, Tabs, Tab, Hidden, MenuItem } from "@material-ui/core";

import InputAdornment from "@material-ui/core/InputAdornment";
import Heading from "../../components/Heading";
import AccountIntegrations from "./AccountIntegrations";
import IntegrationCardsGrid from "./IntegrationCardsGrid";
import  Loading from "../../components/loadingSpinner/Loading";
import EditIcon from "@material-ui/icons/Edit";

import AccountDetails from "./AccountDetails";
import AccountEmail from "./AccountEmail";
import AccountPassword from "./AccountPassword";
import HgBilling from "../../pages/billing/HgBilling"
import PaymentHistory from "../billing/PaymentHistory";
import { ProfileType } from "../../types/enum";
import HgBillingV2 from "../../pages/billing/HgBillingV2"
import PaymentDetails from "../../pages/billing/PaymentDetails"

@inject("profileStore", "templateStore", "userStore", "authStore", "billingStore","googleCalendarStore","myobStore","xeroStore", "hgBillingStore", "hgSuperPayAddonStore")
@withRouter
@observer
class AccountSetting extends Component {
    state = {
        firstName: "",
        lastName: "",
        email: "",
        passwordEditState: false,
        isDirty: false,
        password: "",
        newPassword: "",
        confirmPassword: "",
        showPassword: false,
        isPrivateHireLock: false,
        tab: 0,
        tabDisabled: false,
        isLoading: false,
        isRedirected: false
    };

    handleLoading = (value) => {
        this.setState({ isLoading: value });
    };
    componentDidMount() {
        this.props.userStore.getUserCognito()
        this.props.googleCalendarStore.setGoogleCalendarCode("");
        const { currentUser } = this.props.userStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        this.setState({
            firstName: currentUser.given_name,
            lastName: currentUser.family_name,
            email: currentUser.email,
            firstNameEditState: false,
            lastNameEditState: false,
            emailEditState: false,
            passwordEditState: false,
            isDirty: false,
            password: "",
            newPassword: "",
            confirmPassword: "",
            showPassword: false,
            membershipLock: false
        });

        if (this.props && this.props.match && this.props.match.params && this.props.match.params.tab) {
            if (this.props.match.params.tab === "integration") {
                this.setState({
                    tab: 4
                });
            }
       
            if (this.props.match.params.tab === "lock") {
                this.setState({ tab: 1, tabDisabled: true });
            }
            if(this.props.match.params.tab === "privatehirelock"){
                this.setState({ tab: 2, tabDisabled: true,isPrivateHireLock: true });
            }

            if(this.props.match.params.tab === "checkoutsuccess" || this.props.match.params.tab === "checkoutcancelled"){
                this.setState({ tab: 1});
                // const query = new URLSearchParams(this.props.location.search);
                // const priceId = query.get('priceId')
                // const type = query.get('type')

                this.props.hgBillingStore.reloadAccessSynch()
                this.props.hgSuperPayAddonStore.loadAddonStatus()
            }
            if(this.props.match.params.tab === "addcardsuccess" || this.props.match.params.tab === "addcardcancelled"){
                this.setState({ tab: 2});
                this.props.hgBillingStore.reloadAccessSynch()
            }
            if(this.props.match.params.tab === "xero"){
                const query = new URLSearchParams(this.props.location.search);
                const token = query.get('code')
               
                if(token){
                    var codeStore = decodeURIComponent(token)
                    this.props.xeroStore.setXeroCode(token);
                    const body = {
                        code: codeStore,
                        profileId : currentProfile.id
                    };
                    this.setState({
                        isLoading: true,
                        
                    });
                    this.props.xeroStore.connectXero(body).then(result => {
                        this.props.profileStore.loadProfiles().finally(() => {
                            this.setState({
                                isLoading: false,
                                tab: 4
                            });
                        })
                    })
                    // return agent.MYOB.authorizeMYOB(body).then(result => {
                    //     console.log("diceritakan", result)
                    // });
                }else{
                    this.setState({ tab: 4});
                }
            }
            if(this.props.match.params.tab === "membership"){
                this.setState({ tab: 1}, () => {
                    const query = new URLSearchParams(this.props.location.search);
                    if(query.get("scrollTo") === "addon"){
                        setTimeout(() => {
                            const el = document.getElementById("hg-super-pay-addon");
                            if(el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                        }, 600);
                    }
                });
            }
            if(this.props.match.params.tab === "myob"){
                const query = new URLSearchParams(this.props.location.search);
                const token = query.get('code')
               
                if(token){
                    var codeMyob = decodeURIComponent(token)
                    this.props.myobStore.setMyobCode(token);
                    const body = {
                        code: codeMyob
                    };
                    this.setState({
                        isLoading: true,
                        
                    });
                    this.props.myobStore.connectMyob(currentProfile.id, body).then(result => {
                        this.props.profileStore.loadProfiles().finally(() => {
                            this.setState({
                                isLoading: false,
                                tab: 4
                            });
                        })
                    })
                    // return agent.MYOB.authorizeMYOB(body).then(result => {
                    //     console.log("diceritakan", result)
                    // });
                }else{
                    this.setState({ tab: 4});
                }
              
            }
            if(this.props.match.params.tab === "googlecalendar"){
                const query = new URLSearchParams(this.props.location.search);
                const token = query.get('code')
                this.props.googleCalendarStore.setGoogleCalendarCode(token);
                this.setState({ tab: 4});
            }
        }
        this.props.authStore.setPassword("");
        this.props.authStore.setNewPassword("");
        this.props.authStore.setConfirmPassword("");
        this.handleLoading(true)
        this.props.hgBillingStore.getCustomerAccess().then(() => {
            this.handleLoading(false)
        })
    };

    handleChangeTabMembership = () =>{
        this.setState({ tab: 1});
    }
    handleChangeTab = (event, value) => {
        this.setState({ tab: value });
    };

    handleSelectedTab = (event, value) => {
        this.setState({ tab: value });
    };
    handleSelectChange = event => {
        this.setState({ tab:  event.target.value });
       
    }
    
    render() {
        const {subscriptions} = this.props.hgBillingStore
        const { currentProfileType } = this.props.profileStore;
        const profiles = this.props.profileStore.getCurrentProfile();
        return (
            <div>
                <Header role={this.props.templateStore.getTypeString(currentProfileType || 1)} />
                <Loading showed={this.state.isLoading}/>
                <Sidebar />
                <MainContainer>
                    <Heading title="Account Settings" />
                    
                    <Paper style={{ position: "relative", borderRadius: 12, overflow: "hidden" }}>
                    <Grid container spacing={8}>
                            {
                                !this.state.isRedirected &&
                                <Grid item xs={12} lg={12} style={{ padding: 0 }}>
                                </Grid>
                            }
       


                        {
                            process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" &&
                                <Grid item xs={12} lg={12}>
                                    <Hidden smDown>
                                        <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                                            <Tabs 
                                                value={this.state.tab} 
                                                onChange={this.handleChangeTab}  
                                                indicatorColor="primary" 
                                                textColor="secondary"
                                                scrollable
                                                scrollButtons="off"
                                                classes={{
                                                    root: "tabs-root",
                                                    indicator: "tabs-indicator"
                                                }}
                                            >
                                                <Tab label="Account Details" disabled={this.state.tabDisabled} classes={{ selected: "tab-selected" }} />
                                                <Tab label="Membership" disabled={subscriptions?.parentUserId || this.state.tabDisabled || profiles?.type === ProfileType.PrivateHire.ordinal} classes={{ selected: "tab-selected" }} />
                                                <Tab label="Payment Methods" disabled={subscriptions?.parentUserId || this.state.tabDisabled} classes={{ selected: "tab-selected" }} />
                                                <Tab label="Billing History" disabled={subscriptions?.parentUserId || this.state.tabDisabled} classes={{ selected: "tab-selected" }} />
                                                <Tab label="Pro Integrations" disabled={subscriptions?.parentUserId || this.state.tabDisabled} classes={{ selected: "tab-selected" }} />
                                            </Tabs>
                                        </AppBar>
                                        <br />
                                    </Hidden>
                                    <Hidden mdUp>
                                        <div style={{ padding: 8 }}>
                                            <TextField select value={this.state.tab} onChange={this.handleSelectChange} textColor="primary" fullWidth>
                                                <MenuItem key={0} value={0}>
                                                    Account Details
                                                </MenuItem>
                                                <MenuItem key={1} value={1}>
                                                    Membership
                                                </MenuItem>
                                                <MenuItem key={2} value={2}>
                                                    Payment Methods
                                                </MenuItem>
                                                <MenuItem key={3} value={3}>
                                                    Billing History
                                                </MenuItem>
                                                <MenuItem key={4} value={4}>
                                                    Pro Integrations
                                                </MenuItem>
                                            </TextField>
                                        </div>
                                    </Hidden>
                                    <div className="account-settings-content">
                                        {this.state.tab === 0 && (
                                            <div>
                                                <div className="account-section">
                                                    <div className="section-header">
                                                        <Typography variant="headline" component="h2" className="section-title">Personal Details</Typography>
                                                        <Typography component="p" className="section-description">Update your personal information and account details.</Typography>
                                                    </div>
                                                    <AccountDetails />
                                                </div>
                                                <div className="account-section">
                                                    <div className="section-header">
                                                        <Typography variant="headline" component="h2" className="section-title">Email Address</Typography>
                                                        <Typography component="p" className="section-description">Change the email address associated with your account.</Typography>
                                                    </div>
                                                    <AccountEmail />
                                                </div>
                                                <div className="account-section last">
                                                    <div className="section-header">
                                                        <Typography variant="headline" component="h2" className="section-title">Password</Typography>
                                                        <Typography component="p" className="section-description">Update your password to keep your account secure.</Typography>
                                                    </div>
                                                    <AccountPassword />
                                                </div>
                                            </div>
                                        )}
                                        {this.state.tab === 1 && (
                                            <div>
                                                <div className="section-header">
                                                    <Typography variant="headline" component="h2" className="section-title">Membership</Typography>
                                                    <Typography component="p" className="section-description">Manage your subscription and membership plan.</Typography>
                                                </div>
                                                <Grid container spacing={8}>
                                                    <HgBillingV2 handleLoading={this.handleLoading} isLoading={this.state.isLoading} isPrivateHireLock={this.state.isPrivateHireLock}/>
                                                </Grid>
                                            </div>
                                        )}
                                        {this.state.tab === 2 && (
                                            <div>
                                                <div className="section-header">
                                                    <Typography variant="headline" component="h2" className="section-title">Payment Methods</Typography>
                                                    <Typography component="p" className="section-description">Manage your saved payment methods for subscriptions and billing.</Typography>
                                                </div>
                                                <Grid container spacing={8}>
                                                    <PaymentDetails/>
                                                </Grid>
                                            </div>
                                        )}
                                        {this.state.tab === 3 && (
                                            <div>
                                                <div className="section-header">
                                                    <Typography variant="headline" component="h2" className="section-title">Billing History</Typography>
                                                    <Typography component="p" className="section-description">View your past invoices and payment history.</Typography>
                                                </div>
                                                <Grid container spacing={8}>
                                                    <PaymentHistory handleLoading={this.handleLoading} isLoading={this.state.isLoading} />
                                                </Grid>
                                            </div>
                                        )}
                                        {this.state.tab === 4 && (
                                            <div>
                                                <div className="section-header">
                                                    <Typography variant="headline" component="h2" className="section-title">Pro Integrations</Typography>
                                                    <Typography component="p" className="section-description">Connect your account with third-party services to enhance your workflow.</Typography>
                                                </div>
                                                <IntegrationCardsGrid redirectMembership={this.handleChangeTabMembership} handleLoading={this.handleLoading} />
                                            </div>
                                        )}
                                    </div>
                                </Grid>
                         }
                          {
                                    this.state.isRedirected && process.env.REACT_APP_DISABLE_BILLING_MOBILE === "true" &&
                                    <Grid>
                                          <h3>If you are having issues accessing your account, please contact support@hotgiggity.com</h3>
                                    </Grid>
                                }
                                           
                                {
                                    !this.state.isRedirected && process.env.REACT_APP_DISABLE_BILLING_MOBILE === "true" &&
                                    <Grid item xs={12} lg={12}>
                                          <Hidden smDown>
                                        <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                                            <Tabs 
                                                value={this.state.tab} 
                                                onChange={this.handleChangeTab}  
                                                indicatorColor="primary" 
                                                textColor="secondary"
                                                scrollable
                                                scrollButtons="off"
                                                classes={{
                                                    root: "tabs-root",
                                                    indicator: "tabs-indicator"
                                                }}
                                            >
                                                <Tab label="Account Details" disabled={this.state.tabDisabled} classes={{ selected: "tab-selected" }} />
                                                <Tab label="Pro Integrations" disabled={this.state.tabDisabled} classes={{ selected: "tab-selected" }} />
                                            </Tabs>
                                        </AppBar>
                                        <br />
                                        </Hidden>
                                        <Hidden mdUp>
                                            <div style={{ padding: 8 }}>
                                                <TextField select value={this.state.tab} onChange={this.handleSelectChange} textColor="primary" fullWidth>
                                                    <MenuItem key={0} value={0}>
                                                        Account Details
                                                    </MenuItem>
                                                    <MenuItem key={1} value={1}>
                                                        Pro Integrations
                                                    </MenuItem>
                                                </TextField>
                                            </div>
                                        </Hidden>
                                        <div className="account-settings-content">
                                            {this.state.tab === 0 && (
                                                <div>
                                                    <div className="account-section">
                                                        <div className="section-header">
                                                            <Typography variant="headline" component="h2" className="section-title">Personal Details</Typography>
                                                            <Typography component="p" className="section-description">Update your personal information and account details.</Typography>
                                                        </div>
                                                        <AccountDetails />
                                                    </div>
                                                    <div className="account-section">
                                                        <div className="section-header">
                                                            <Typography variant="headline" component="h2" className="section-title">Email Address</Typography>
                                                            <Typography component="p" className="section-description">Change the email address associated with your account.</Typography>
                                                        </div>
                                                        <AccountEmail />
                                                    </div>
                                                    <div className="account-section last">
                                                        <div className="section-header">
                                                            <Typography variant="headline" component="h2" className="section-title">Password</Typography>
                                                            <Typography component="p" className="section-description">Update your password to keep your account secure.</Typography>
                                                        </div>
                                                        <AccountPassword />
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.tab === 1 && (
                                                <div>
                                                    <div className="section-header">
                                                        <Typography variant="headline" component="h2" className="section-title">Pro Integrations</Typography>
                                                        <Typography component="p" className="section-description">Connect your account with third-party services to enhance your workflow.</Typography>
                                                    </div>
                                                    <IntegrationCardsGrid redirectMembership={this.handleChangeTabMembership} handleLoading={this.handleLoading} />
                                                </div>
                                            )}
                                        </div>
                                    </Grid>

                                }
                        </Grid>
                       
                    </Paper>
                </MainContainer>
            </div>
        );
    }
}

export default AccountSetting;
